export default function NewSongAction(actionContext, payload) {
    return actionContext.dispatch('NEW_SONG');
}
